import React from 'react';
interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}
export function GlassCard({
  children,
  className = '',
  hoverEffect = false,
  onClick
}: GlassCardProps) {
  return <div className={`
        glass-panel rounded-2xl p-6 md:p-8 
        ${hoverEffect ? 'glass-card-hover' : ''} 
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} onClick={onClick} data-id="element-133">
      {children}
    </div>;
}